import { rupiah } from "@/lib/format";
import { Warehouse } from "lucide-react";

const kg = (v) => `${Number(v || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })} Kg`;

export const ProdukStokCards = ({ items, testid }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5" data-testid={testid}>
    {items.map((p) => (
      <div key={p.produk_id} className="card-flat p-4" data-testid={`${testid}-${p.produk_id}`}>
        <div className="flex items-center justify-between">
          <div className="text-[11px] uppercase tracking-widest text-slate-500 truncate" title={p.nama}>Stok {p.nama}</div>
          <Warehouse size={15} className="text-indigo-600"/>
        </div>
        <div className="mt-2 font-mono text-lg md:text-xl text-slate-900 tabular-nums">{kg(p.sisa_stok_kg)}</div>
        <div className="text-[11px] text-slate-500 mt-0.5">HPP rata-rata {rupiah(p.hpp_rata)}/Kg</div>
      </div>
    ))}
  </div>
);
